import "reflect-metadata";

import { Container } from "inversify";

import { authModuleContainer } from "./modules/auth/auth.ioc";
import { sessionModuleContainer } from "./modules/session/session.ioc";
import { clientModuleContainer } from "./modules/client/client.ioc";
import { errorModuleContainer } from "./modules/error/error.ioc";
import { eventsModuleContainer } from "./modules/events/events.ioc";
import { configModuleContainer } from "./modules/config/config.ioc";
import { websocketModuleContainer } from "./modules/websocket/websocket.ioc";
import { rbacModuleContainer } from "./modules/rbac/rbac.ioc";
import { loggerModuleContainer } from "./modules/logger/logger.ioc";
import { telemetryModuleContainer } from "./modules/telemetry/telemetry.ioc";
import { telemetrySdkClientModuleContainer } from "./modules/telemetrySdkClient/telemetrySdkClient.ioc";
import { rateLimiterModuleContainer } from "./modules/ratelimiter/ratelimiter.ioc";
import { storageModuleContainer } from "~/modules/storage/storage.ioc";
import { withContainer } from "./backend/openApi.container";

export function createContainer(): Container {
    const container = new Container();
    container.load(authModuleContainer);
    container.load(configModuleContainer);
    container.load(sessionModuleContainer);
    container.load(clientModuleContainer);
    container.load(errorModuleContainer);
    container.load(eventsModuleContainer);
    container.load(websocketModuleContainer);
    container.load(rbacModuleContainer);
    container.load(loggerModuleContainer);
    container.load(telemetryModuleContainer);
    container.load(telemetrySdkClientModuleContainer);
    container.load(rateLimiterModuleContainer);
    container.load(storageModuleContainer);
    withContainer(container);
    return container;
}

let singletonContainer: Container;
export function getSingletonContainer(): Container {
    if (!singletonContainer) {
        singletonContainer = createContainer();
    }

    return singletonContainer;
}
